import { Alert, Box, CircularProgress, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ProfileLoaderProps {
    isLoading: boolean;
    loadError?: string | null;
}

export default function ProfileLoadingStatus({ isLoading, loadError }: ProfileLoaderProps) {
    const { t } = useTranslation('profile');

    return (
        <>
            { isLoading && (
                <LoadingContainer>
                    <CircularProgress />
                </LoadingContainer>
            ) }
        
            { loadError && (
                <Alert severity="error">
                    { t('error.loadFailed') }
                </Alert>
            ) }
        </>
    );
}


const LoadingContainer = styled(Box)(({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px'
}));
